import React from "react"
import { useState, useEffect } from "react"
import {
    Box,
    FormControl,
    IconButton,
    Stack,
    Autocomplete,
    TextField,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Paper,
    TablePagination,
    Typography,
} from "@mui/material"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import "react-datepicker/dist/react-datepicker.css"
import { useDispatch, useSelector } from "react-redux"
import type { RootState } from "../../../global/config/store.ts"
import { toast } from "react-toastify"
import { setSelectedClientGroup } from "../../../global/config/Reducer/clientSlice.ts"
import { setDate } from "../../../global/config/Reducer/dateSlice.ts"
import { ApiGetPendingAllocation } from "../../../apiService/Core/Apicall.tsx"

export default function PendingAllocation() {
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
    const dispatch = useDispatch()
    const [currentDate, setCurrentDate] = useState(new Date(selectedDateRedux))
    const [allocations, setAllocations] = useState<any>([])
    const Clientlist = useSelector((state: RootState) => state.client.clientList)
    const [selectedClient, setSelectedClient] = useState<any>(selectedClientName)
    const [ClientId, setClientId] = useState(null)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [datalength, setdatalength] = useState<any>(null);

    useEffect(() => {
        if (Clientlist.length > 2) {
            setClientId(Clientlist[2].clientGroupName)
        }
    }, [Clientlist])

    const handlePrevMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1)
            dispatch(setDate(newDate))
            return newDate
        })
    }

    const handleNextMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1)
            dispatch(setDate(newDate))
            return newDate
        })
    }

    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01")
        setCurrentDate(newDate)
    }

    useEffect(() => {
        selectedClientName && setSelectedClient(selectedClientName)
    }, [selectedClientName])

    useEffect(() => {
        if (selectedDateRedux) {
            setCurrentDate(new Date(selectedDateRedux))
        }
    }, [selectedDateRedux])


    // ------------------------------------------- Chnage Pagination -----------------------------------------------
    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const formatDate = (date: Date) => {
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`
    }

    const getPendingAllocation = async () => {
        try {
            const data = `?month=${currentDate.getMonth() + 1}&year=${currentDate.getFullYear()}&clientGroupName=${selectedClient.clientGroupName}`
            const res = await ApiGetPendingAllocation(data);
            if (res.status) {
                setAllocations(res.data)
            }
        } catch (error: any) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                String(error);
            toast.error(message)
        }
    }

    useEffect(() => {
        if (selectedClient && currentDate) {
            getPendingAllocation()
        }
    }, [selectedClient, currentDate])

    return (
        <div>
            <Box sx={{ p: 4 }} style={{ background: "white" }}>
                <Stack spacing={3}>
                    <Box sx={{ width: "100%" }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: 'center',
                                justifyContent: "space-between",
                                mb:3
                            }}
                        >
                            <Stack direction="row" spacing={2}>
                                <FormControl size="small" sx={{ width: 180 }}>
                                    <Autocomplete
                                        disablePortal
                                        id="mm-autocomplete"
                                        options={Clientlist}
                                        value={selectedClient}
                                        getOptionLabel={(option) => option?.clientGroupName}
                                        isOptionEqualToValue={(option, value) => option.clientGroupDBName === value.clientGroupDBName}
                                        onChange={(event, newValue: any) => {
                                            // setSelectedClient(newValue)
                                            dispatch(setSelectedClientGroup(newValue))
                                            setClientId(newValue?.clientGroupName || null)
                                        }}
                                        // defaultValue="mmcommon"
                                        renderInput={(params) => <TextField {...params} label="Select Client" />}
                                        size="small"
                                    />
                                </FormControl>

                            </Stack>
                            <Box>
                                <h1 className="common-manage-h1 mb-2" style={{ textAlign: "center" }}>
                                    Pending Allocations
                                </h1>
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    // marginBottom: "70px",
                                }}
                            >
                                <IconButton onClick={handlePrevMonth}>
                                    <ChevronLeftIcon />
                                </IconButton>
                                <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
                                    <input
                                        type="month"
                                        value={formatDate(currentDate)}
                                        onChange={handleDateChange}
                                        className="primary-color"
                                        style={{
                                            border: "none",
                                            background: "none",
                                            fontSize: "1.25rem",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            fontFamily: "inherit",
                                        }}
                                    />
                                </Box>
                                <IconButton onClick={handleNextMonth}>
                                    <ChevronRightIcon />
                                </IconButton>
                            </Box>
                        </Box>
                    </Box>
                </Stack>
                <Box>
                    <TableContainer
                        component={Paper}
                        sx={{ mb: 4, border: "1px solid #ccc" }}
                    >
                        <Table>
                            <TableHead sx={{ bgcolor: "#7a7d52" }}>
                                <TableRow>
                                    <TableCell sx={{ color: 'white' }}>Business Name</TableCell>
                                    <TableCell sx={{ color: 'white' }}>Site Name</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {allocations?.length > 0 ? (
                                    allocations?.sort((a: any, b: any) => a.clientEntityName?.localeCompare(b.clientEntityName))?.map((items: any) => (
                                        <TableRow>
                                            <TableCell>
                                                {items?.clientEntityName}
                                            </TableCell>
                                            <TableCell>
                                                {items?.venueName}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={2}>
                                            <Typography>No Pending Allocation Found.</Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                        {/* <TablePagination
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            component="div"
                            count={datalength}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        /> */}
                    </TableContainer>
                </Box>
            </Box>
        </div >
    )
}
